import { useEffect, useState } from "react";

/**
 * @example
 * const { setTarget } = useInfiniteScroll(fn);
 * <div ref={setTarget} /> 와 같이 사용합니다.
 *
 * @param onIntersect target element가 노출되었을 때 실행할 함수
 * @param onNotIntersect target element가 노출되지 않았을 때 실행할 함수
 */
export function useInfiniteScroll(onIntersect: () => void, onNotIntersect?: () => void) {
  const [target, setTarget] = useState<Element | null>(null);

  useEffect(() => {
    let observer: IntersectionObserver;

    if (target) {
      observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            onIntersect();
          } else {
            onNotIntersect?.();
          }
        },
        { threshold: 1 },
      );
      observer.observe(target);
    }

    return () => observer?.disconnect();
  }, [onIntersect, onNotIntersect, target]);

  return { setTarget };
}
